// eslint-disable-next-line no-shadow
export enum ProfessionalProfileType {
  COMMUNICATOR = 'COMMUNICATOR',
  EXECUTOR = 'EXECUTOR',
  IDEALIZER = 'IDEALIZER',
  ANALYST = 'ANALYST',
}
